export const requestInviteParam = 'requestInvite'
export const loginRedirectParam = 'loginRedirect'
export const loginHintParam = "loginHint";

/** Centralize url's we using w/in the app, in redirects, etc. */
export const AppUrls = {
  requestInvite: () => `/?${requestInviteParam}`,
}
